import React, { memo } from "react";
import logo218 from "../images/assets/logo218.svg"

function CheckoutProgressBar({ address, payment }) {
  return (
    <div className="row">
      <div className="container">
        <div className="checkout-wrap p-2 p-sm-3">
          <ul
            id="checkout-bar"
            className={`${address && "step1"} ${payment && "step2"} `}
          >
            {/* <img src={logo218} ></img> */}
            <li className="step1">
              <span 
              tw="text-xs sm:text-base"
                // className="text-black"
                style={{ color: " #f0b917" }}
              > ADDRESS</span>
            </li>
            <li className="step2">
              <span 
              tw="text-xs sm:text-base"
                // className="text-black"
                style={{ color: " #f0b917" }}
              >PAYMENT </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default memo(CheckoutProgressBar);